import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import { withSizes } from 'react-sizes';
import { Link } from '../../routes';
import { Gold, Triangle, slugify, getProductTypeName } from '../../utils';
import { DropdownContainer } from '../../containers/index';
import { Button } from "../index";

import {
  ReviewsInfo,
  ReviewsPhoto,
  ReviewsDropdown,
  ReviewsInfoContainer,
  ReviewsFeaturesList,
  HotelName,
  ReviewsPanelStats,
  ReviewsPanelVotes,
  ReviewsPanelContainer,
  ReviewsButtonContainer,
  ReviewsPanelFeatureWrapper,
  ReviewsPanelWays,
  ReviewsPanelFeature,
  ReviewsPanelDescription,
  ReviewsPanelFooter,
} from './styles';

export const ReviewsDropdownContainer = ({ selectedHotel, hotels, toggleDropdown, dropdownOpened }) => (
  <ReviewsPanelFeatureWrapper>
    <ReviewsPanelFeature onClick={toggleDropdown}>
      <h3>Choose Hotel</h3>
      <div className="panel-container">
        <span style={{ fontWeight: 700, color: '#5a5a5a' }}>{selectedHotel && selectedHotel.hotelName || 'Select a hotel'}</span>
        <Triangle width={13} height={10} color="#1EB6FF" />
      </div>
    </ReviewsPanelFeature>
    {dropdownOpened && (
      <DropdownContainer
        name="hotel"
        noPadding
        handleCloseButtonClick={toggleDropdown}
        onClickOutside={toggleDropdown}
      >
        <ReviewsDropdown>
          <Link href="/hotel-reviews">
            <a>
              <ReviewsPanelWays>
                <b>See all reviews</b>
              </ReviewsPanelWays>
            </a>
          </Link>
          {hotels.map(hotel => {
            const { hotelId, hotelName, marketLocationName } = hotel;
            return (
              <Link
                route="hotel-reviews"
                params={{
                  marketName: slugify(marketLocationName),
                  hotelName: slugify(hotelName),
                  hotelId,
                }}
                key={hotelId}
              >
                <a>
                  <ReviewsPanelWays>
                    {hotelName}
                  </ReviewsPanelWays>
                </a>
              </Link>
            )
          })}
        </ReviewsDropdown>
      </DropdownContainer>
    )}
  </ReviewsPanelFeatureWrapper>
);

ReviewsDropdownContainer.propTypes = {
  selectedHotel: PropTypes.instanceOf(Object),
  hotels: PropTypes.instanceOf(Object),
  toggleDropdown: PropTypes.func,
  dropdownOpened: PropTypes.bool,
};

const ReviewsPanel = ({ selectedHotel, hotels, toggleDropdown, dropdownOpened, isTablet, counter }) => (
  <ReviewsPanelContainer>
    <ReviewsDropdownContainer selectedHotel={selectedHotel} hotels={hotels} toggleDropdown={toggleDropdown} dropdownOpened={dropdownOpened} />
    {selectedHotel && selectedHotel.hotelId ? (
      <Fragment>
        <ReviewsInfo>
          <ReviewsPhoto>
            <img src={`${process.env.CDN_URL}${selectedHotel.productImage}`} alt={selectedHotel.hotelName} />
          </ReviewsPhoto>
          <ReviewsInfoContainer>
            <ReviewsFeaturesList>
              <li>{selectedHotel.productName}</li>
              <li>{selectedHotel.marketLocationName}</li>
            </ReviewsFeaturesList>
            <HotelName>{selectedHotel.hotelName}</HotelName>
            <ReviewsPanelStats>
              <StarRatings
                rating={selectedHotel.ratingCalc === 0 || !selectedHotel.ratingCalc ? 5 : selectedHotel.ratingCalc}
                numberOfStars={5}
                starRatedColor="#1eb6ff"
                starEmptyColor="#b6e4f9"
                starDimension="15px"
                starSpacing="0px"
              />
              <ReviewsPanelVotes>{selectedHotel.totalReviews}</ReviewsPanelVotes>
            </ReviewsPanelStats>
          </ReviewsInfoContainer>
        </ReviewsInfo>
        <ReviewsButtonContainer>
          <Link
            route="product"
            params={{
              marketName: slugify(selectedHotel.marketLocationName),
              hotelName: slugify(selectedHotel.hotelName),
              hid: selectedHotel.hotelId,
              pid: selectedHotel.productId,
            }}
          >
            <a>
              <Button as="span" theme="primary">{isTablet ? 'View' : `View ${getProductTypeName(selectedHotel.productType, 2)}`}</Button>
            </a>
          </Link>
        </ReviewsButtonContainer>
        {!isTablet && (
          <ReviewsPanelFooter>
            <Gold />
            <ReviewsPanelDescription>
              It&apos;s been viewed {counter} times in the past week.
            </ReviewsPanelDescription>
          </ReviewsPanelFooter>
        )}
      </Fragment>
    ) : null}
  </ReviewsPanelContainer>
);

ReviewsPanel.propTypes = {
  selectedHotel: PropTypes.instanceOf(Object),
  hotels: PropTypes.instanceOf(Object),
  toggleDropdown: PropTypes.func,
  dropdownOpened: PropTypes.bool,
  isTablet: PropTypes.bool,
  counter: PropTypes.number,
};

const mapSizesToProps = ({ width }) => ({
  isTablet: width <= 768,
});

export default withSizes(mapSizesToProps)(ReviewsPanel);
